import { ReactNode } from 'react';

import { SidebarMenuSubItem, SidebarMenuSubButton } from '@/components/organisms/Sidebar/Sidebar';
import { cn } from '@/helpers/shadCnUtils';

interface SidebarSubItemProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}

export function SidebarSubItem({ children, onClick, className }: SidebarSubItemProps) {
  return (
    <SidebarMenuSubItem className={cn('cursor-pointer hover:bg-gray-100/20', className)}>
      <SidebarMenuSubButton asChild onClick={onClick}>
        <span>{children}</span>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
}
